
    import {Component, Vue, Watch} from 'vue-property-decorator'
    import AppendixDialog from "@/views/orderManage/template/AppendixDialog.vue";
    import {
      getOrderInfoApp,
      launchReturnOrder,
      OrderDtlApi,
      OrderDtlResApi, OrderListDto,
      ReturnOrderDtlParamsApi
    } from '@/api/order'
    import SelectGoods from "@/views/orderManage/template/SelectGoods.vue";
    import {AccountInfoListApi, AppendixFileDto, getCompanyAccountInfo} from "@/api/commonConfig";
    import AppendixName from "@/components/AppendixName/index.vue";
    import {Getter} from "vuex-class";
    import math from "@/core/math";
    import Clipboard from 'clipboard'

    @Component({
        name: 'ValetRefund',
        components: {AppendixDialog, SelectGoods, AppendixName}
    })
    export default class ValetRefund extends Vue {
        @Getter companyId!: string

        isEdit = false
        returnOrderDtl: OrderDtlResApi[] = []
        returnOrderDtlSelect: OrderDtlResApi[] = []
        params = {
            companyId: '',
            orderId: '',
            currRouteId: ''
        }
        selectOrderDtl: ReturnOrderDtlParamsApi[] = []

        amountMoney = 0
        returnMoneySum = 0
        orderInfo: OrderListDto = {}
        accountInfo: AccountInfoListApi = {}

        @Watch('returnOrderDtlSelect', {deep: true})
        changeGoodsList(val: OrderDtlResApi[]) {
            this.selectOrderDtl = []
            if (val && val.length > 0) {
                this.amountMoney = 0
                val.forEach((item) => {
                    if (item.isChecked) {
                        this.amountMoney = Number(math.mathAdd(this.amountMoney, math.mathMultiply(item.salePrice, item.saleAmount || 0)))
                        this.returnMoneySum = this.amountMoney
                        this.selectOrderDtl.push({
                            orderDtlId: item.orderDtlId,
                            returnAmount: item.saleAmount,
                            returnMoney: item.salePrice
                        })
                    }
                })
            }
        }

        created () {
            this.params.companyId = this.companyId
            this.params.orderId = this.$route.query.orderId as string
            this.params.currRouteId = this.$route.query.currRouteId as string

            this.getInfo()
        }

        handleBack () {
            this.$confirmDialog.show({
                okText:"确认",
                cancelText:"取消",
                tips:"退出后将清空已录入内容，是否确认退出?",
                onOk:()=>{
                    return this.$router.back()
                },
            })
        }

        // 获取银行账卡信息
        getAccountInfo () {
            getCompanyAccountInfo({ companyId: this.orderInfo.customerId }).then((res) => {
                const data = res.data.accountList || []
                if (data && data.length > 0) {
                    this.accountInfo = data[0]
                } else {
                    this.accountInfo = {}
                }
            })
        }

        // 获取订单详情信息
        getInfo () {
            getOrderInfoApp(this.params).then((res) => {
                this.orderInfo = res.data || {}
                // 清除掉附件信息
                this.orderInfo.orderFile = []
                // 过滤掉可退数量为0的商品
                this.returnOrderDtl = res.data.orderDtlList.filter(item => item.returnSaleAmount) || []

                this.returnOrderDtlSelect = JSON.parse(JSON.stringify(this.returnOrderDtl))
                this.returnOrderDtlSelect.map((item) => {
                    item.isChecked = true
                    return item
                })

                this.getAccountInfo()
            })
        }

        /* 获取上传附件信息 */
        getUploadInfo (data: AppendixFileDto[]) {
          this.$set(this.orderInfo, 'orderFile ', data)
        }

        /**
         * @description: 监听复制
         * @param {*} e 复制内容
         * @return {*}
         */
        copyCode (key) {
          let clipboard = new Clipboard('.copy', {
            text: trigger => key
          })
          clipboard.on('success', e => {
            this.$toast('复制成功')
          })
          clipboard.on('error', e => {
            this.$toast('该浏览器不支持复制')
            e.clearSelection()
          })
        }

        /* 显示上传附件弹窗 */
        showUploadFunc() {
            (this.$refs.appendix as any).show({
                fileType: '6',
                orderFile:this.orderInfo.orderFile
            })
        }

        /**
         * 调用原生方法切换银行账户
         */
        selectAccountInfo() {
            const data = {
                customerId: this.orderInfo.customerId,
                isShowTemporary: true, // 是否展示临时账户信息 传false就是不展示，true就是展示
                title: '选择退款账户'
            }
            this.$bridge.callHandler('enterSelectAccountInfo', {data}, (res) => {
                const data = !res ? {} : JSON.parse(res)
                this.accountInfo = data;
            })
        }

        selectGoods () {
            (this.$refs.selectGoods as any).show(this.returnOrderDtl, this.returnOrderDtlSelect)
        }

        getSelectGoods (data: OrderDtlResApi[]) {
            this.returnOrderDtlSelect = data
        }

        submitOrder() {
            if (!this.accountInfo.accountId) {
                return this.$toast('请选择退款账户')
            }

            if (!this.selectOrderDtl || this.selectOrderDtl.length <= 0) {
                return this.$toast('请选择退货商品')
            }

            if (!this.returnMoneySum || Number(this.returnMoneySum) === 0) {
                return this.$toast('请输入获批退款金额')
            }

            if (!this.orderInfo.orderRemark) {
                return this.$toast('请输入退单备注')
            }

            const param = {
                orderId: this.params.orderId,
                companyId: this.params.companyId,
                createTime: this.orderInfo.createTime,
                customerId: this.orderInfo.customerId,
                // companyName: this.orderInfo.customerName,
                levelId: this.orderInfo.customerLever,
                // returnMoney: this.amountMoney,
                returnOrderType: 2,
                returnMan: this.accountInfo.accountName,
                returnManBank: this.accountInfo.accountBank,
                receiveManBankNo: this.accountInfo.accountId,
                orderFileList:this.orderInfo.orderFile,
                orderRemark: this.orderInfo.orderRemark,
                returnMoneySum: this.returnMoneySum,
                currRouteId: this.orderInfo.currRouteId,
                returnOrderDtl: this.selectOrderDtl
            }
            console.log(param)

            launchReturnOrder(param).then((res) => {
                this.$toast.success({
                    message: '退单成功',
                    duration: 1000,
                    onClose: () => {
                        // 去订单页
                        this.$router.push({
                            path: '/salesOrderList',
                            params: {
                                orderToggle: '1',
                            }
                        })
                    }
                })
            })
        }

        /**
         * 格式化金额 仅可录入数字，最少为0.00，最大为99999999.99，格式化去掉数字前面的0
         * @param value
         */
        formatterMoney(value) {
            value = Number(value) > 99999999.99 ? '99999999.99' : value
            return value.replace(/[^0-9.]/g,'').replace(/^(\\-)*(\d+)\.(\d\d).*$/,'$1$2.$3').replace(/0*(\d+)/,'$1')
        }

        // 编辑金额
        editAmount() {
            this.isEdit = true
        }
    }
